import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-intro-check',
  templateUrl: './intro-check.component.html',
  styleUrls: ['./intro-check.component.scss'],
})
export class IntroCheckComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
